import { DynamicFieldType } from '@page-components/shipment/common';
import { CommonUtility } from '@utility/common';
import { FlexNestedTableRow } from '../styles/common';
import { Field } from './Field';
import type { ShipmentDynamicFieldType } from '@hooks/shipment';

type FlexNestedTableProps = {
  errors: Record<string, any>[];
  fields: ShipmentDynamicFieldType[];
  onChange: (value: any) => void;
  onPressEnter?: () => void;
  rows: any[];
  isBox?: boolean;
  label?: string;
  defaultValues?: any[];
  [key: string]: any;
};

export function FlexNestedTable(props: FlexNestedTableProps) {
  const {
    errors,
    fields,
    onChange,
    onPressEnter,
    rows,
    isBox,
    label,
    defaultValues,
  } = props;

  const nestedOnChange = (name, value, index) => {
    const temp = rows.map((item, rIndex) => {
      if (index === rIndex) {
        return {
          ...item,
          [name]: value,
        };
      }
      return item;
    });
    onChange(temp);
  };

  const filteredColumns = fields.filter(
    x => x.inputType !== DynamicFieldType.hidden,
  );

  const optionsOfDropdown = (item, i) => {
    if (
      item.inputType === DynamicFieldType.dropdown &&
      CommonUtility.isValidArray(defaultValues)
    ) {
      const defaultRow = defaultValues[i];
      if (CommonUtility.isValidArray(defaultRow?.[`${item.name}-options`])) {
        return {
          ...item,
          options: defaultRow?.[`${item.name}-options`],
        };
      }
    }
    return item;
  };

  return (
    <div className={isBox ? 'has-boxes' : ''}>
      {rows.map((row, index) => (
        <FlexNestedTableRow
          className={`${isBox ? 'box-container' : ''} sk:flex! sk:flex-wrap!`}
          key={index}
        >
          {isBox && <div className="header">{`${label} #${index + 1}`}</div>}
          {filteredColumns.map((itemField, i) => (
            <Field
              {...props}
              key={itemField.name}
              rowValue={row}
              value={row[itemField.name]}
              error={errors ? errors[index][itemField.name] : null}
              item={optionsOfDropdown(itemField, index)}
              onChange={(name, value) => nestedOnChange(name, value, index)}
              index={index}
              onPressEnter={
                fields.filter(x =>
                  [
                    DynamicFieldType.currency,
                    DynamicFieldType.number,
                    DynamicFieldType.text,
                  ].includes(x.inputType),
                ).length ===
                i + 1
                  ? onPressEnter
                  : undefined
              }
              style
              layoutClass={itemField.layoutClass}
            />
          ))}
        </FlexNestedTableRow>
      ))}
    </div>
  );
}
